import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const menus = [
  { section: 'Dashboard' },
  { path: '/dashboard',         icon: 'bi-speedometer2',           label: 'Dashboard' },
  { section: 'Controle de Ponto' },
  { path: '/registro-ponto',    icon: 'bi-fingerprint',            label: 'Registro de Ponto' },
  { path: '/ponto-individual',  icon: 'bi-person-badge',           label: 'Ponto Individual' },
  { path: '/saldo-negativo',    icon: 'bi-graph-down-arrow',       label: 'Saldo Negativo' },
  { path: '/proposta',          icon: 'bi-clipboard2-check',       label: 'Proposta' },
  { path: '/compensacoes',      icon: 'bi-calendar2-check',        label: 'Compensações' },
  { path: '/relatorio-vr', icon: 'bi-receipt-cutoff', label: 'Relatório de VR' },
  { path: '/relatorios',        icon: 'bi-bar-chart-line',         label: 'Relatórios' },
  { section: 'Importação' },
  { path: '/importar-registros',icon: 'bi-file-earmark-spreadsheet', label: 'Folha de Ponto' },
  { section: 'Cadastros' },
  { path: '/funcionarios',      icon: 'bi-people',                 label: 'Funcionários' },
  { path: '/jornadas',          icon: 'bi-calendar2-week',         label: 'Jornadas' },
  { path: '/afastamentos',      icon: 'bi-person-x',               label: 'Afastamentos' },
  { path: '/jornada-extra',     icon: 'bi-calendar2-plus',         label: 'Jornada Extra' },
  { path: '/feriados',          icon: 'bi-calendar-heart',         label: 'Feriados' },
  { section: 'Análises' },
  { path: '/ocorrencias-jornada', icon: 'bi-exclamation-diamond-fill', label: 'Ocorrências Jornada' },
];

export default function Sidebar({ open, onClose }) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      {open && (
        <div className="d-md-none position-fixed top-0 start-0 w-100 h-100"
          style={{ background: 'rgba(0,0,0,0.45)', zIndex: 199 }}
          onClick={onClose} />
      )}
      <div className={`sidebar ${open ? 'open' : ''}`}>
        <div className="sidebar-brand">
          <div className="brand-icon"><i className="bi bi-clock-fill"></i></div>
          <div className="sidebar-brand-text">
            <h5>App Ponto</h5>
            <small>Controle de Ponto</small>
          </div>
        </div>

        <nav className="sidebar-nav">
          {menus.map((item, i) =>
            item.section ? (
              <div key={i} className="sidebar-section-label">{item.section}</div>
            ) : (
              <div key={item.path}
                className={`nav-item-custom ${location.pathname === item.path ? 'active' : ''}`}
                onClick={() => { navigate(item.path); onClose?.(); }}>
                <i className={`bi ${item.icon}`}></i>
                <span>{item.label}</span>
              </div>
            )
          )}
        </nav>

        <div className="sidebar-footer">© 2024 App Ponto v1.0</div>
      </div>
    </>
  );
}
